<template>
    <transition name="slide-fade">
        <div class="dialog-view" v-if="dialogVisible" ref="modal">     
            <div class="u-window m-invite-modal">           
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <h5 class="title t-apply"></h5>
                    <div class="dialog-body">
                        <div class="share-text" v-if="!check">
                            <p>请确认是否接受来自<b>{{ player_data.nickName }}</b>的招募邀请。</p>
                        </div>

                        <div class="share-text" v-else>
                            <p>请求已发送，请点击游戏右侧“玩家回归”按钮<img :src="require('@/assets/images/modal/img-back_btn.png')">，在右下角“招募请求”界面确认<img :src="require('@/assets/images/modal/img-back_btn2.png')">，完成绑定。</p>
                        </div>

                        <p class="notice">活动期间，同时只能接受一个邀请，请仔细确认。</p>

                        <!-- <div class="reward-view" v-if="giftList[1].length">
                            <div class="reward-item" v-for="(item,index) in giftList[1]" :key="index">
                                <div class="r-wrapper">
                                    <div class="pic" v-tips="item.giftId">
                                        <game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item>
                                    </div>
                                </div>                                
                            </div>
                        </div> -->

                    </div>
    
                    <div class="u-ctrl" v-if="!check">
                        <div class="u-btn apply" @click="apply"></div>
                        <div class="u-btn cancel" @click="destroyElement"></div>
                    </div>
                    
                    <div class="u-ctrl" v-else>
                        <div class="u-btn ok" @click="destroyElement"></div>
                    </div>                    
                </div>         
            </div>
            <div class="u-mask"></div>
        </div>
    </transition>      
 </template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            error_text : '请稍后再试',
            check : false,
            giftList : [
                [{ giftId : 'AM99', sendNum : 1 },{ giftId : 'F887', sendNum : 200 },{ giftId : 'MG50', sendNum : 1000 },{ giftId : '1', sendNum : 600 },],
                [{ giftId : 'MG50', sendNum : 500 },{ giftId : 'LP98', sendNum : 1 },{ giftId : 'F887', sendNum : 300 },{ giftId : 'LE96', sendNum : 1 },{ giftId : 'AN07', sendNum : 10 },],
            ],
            mode : 2,            
        }
    },
    created (){
        this.render();
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$store.commit("$_setCode", '');
            localStorage.setItem('code', '');
            this.$clear_code();     
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            this.$axios.get(ajax_url_map.invite_info,{
                params : {
                    code : this.code,
                }
            })
            .then(res => {
                this.player_data = res.data;
            },rej => {
                //this.destroyElement();
                //this.$toast('请稍后再试')
                this.team_switch = true;
                this.error_text = rej.message;
                this.$toast(rej.message);
                this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    this.$clear_code();              
            });
        },
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            this.$axios.post(ajax_url_map.apply_invite,{
                code : this.code,
            })
            .then(
                res => {
                    //this.destroyElement();
                    this.check = true;
                    //this.$toast('助力成功')
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    this.$clear_code();
                },
                rej => {
                    //let text = rej.code == 1000 ? '招募失败，请重新确认' : rej.message;
                    let text = rej.code == 1012 ? '只能被招募1次，招募失败！' : rej.message
                    text = rej.code == 1013 ? '您已被该好友成功邀请，每个好友只限1次' : text;
                    this.destroyElement();
                    this.$toast(text);
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    this.$clear_code();
                }
            );
        },                
    },
}
</script>

<style scoped>
/* share */
.m-invite-modal {
    position: relative;
    width: 629px;
    height: 379px;
    font-size: 22px;
    color: #49392e;
    background-image: url(~@/assets/images/modal/bg-modal-share.png);
}

.t-apply{
    width: 516px;
    height: 55px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/modal/title-invite-apply.png);
}

.dialog-wrapper{
    padding: 20px 38px 0;
}

.share-text{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
}

.share-text b{
    padding: 0 10px;
    word-break: break-all;
    color: #305783;
}

.notice{
    text-align: center;
    font-size: 20px;
    color: #bd4a4a;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 27px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.apply{
    width: 239px;
    height: 84px;
    margin: 0 34px 0;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 239px;
    height: 84px;
    margin: 0 34px 0;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

.u-ctrl .u-btn.ok{
    width: 239px;
    height: 84px;
    margin: 0 34px 0;
    background-image: url(~@/assets/images/modal/btn-know.png);    
}

.reward-view{
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    margin: 10px 0 20px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
    background-image: url(~@/assets/images/pc/bg-item.png);   
}

.r-wrapper{
    width: 69px;
    height: 69px;
}

.r-wrapper>.pic{
    width: 100%;
    height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/InviteApply/inviteApply.vue